enum Strings {
  HomeTitle = "horik.",
  HomeHeadline = "Investigating key areas of digital art practice that have gained in prominence in recent years, including the emergence and impact of location-based media, interactive public installation, augmentative and mixed reality, social networking and file-sharing and mobile technologies.",
  CreditsFooterNote = `If you encounter any issues, have suggestions for improvement, or would like to report any discrepancies, please don't hesitate to contact me on the socials provided at "Contact" section from the bottom of the home page.`,
  CopyrightHorik = "© 2024 Crişan Horea. All Rights Reserved."
}

enum Urls {
  Github = "https://github.com/horikandthepurpleshrooms",
  Mastodon = "https://sunny.garden/@horik",
  Fontshare = "https://www.fontshare.com/",
  FontshareSatoshiFont = "https://www.fontshare.com/fonts/satoshi",
  Freesounds = "https://freesound.org/",
  RetroPickup1Sound = "https://freesound.org/people/MaoDin204/sounds/717684/",
  RetroCoinCollect1Sound = "https://freesound.org/people/MaoDin204/sounds/717681/",
  RetroCoinCollect2Sound = "https://freesound.org/people/MaoDin204/sounds/717682/",
  RetroPowerUp3 = "https://freesound.org/people/MaoDin204/sounds/717699/",
  FreesoundsMaoDin204 = "https://freesound.org/people/MaoDin204/"
}
enum UrlsLicenses {
  CC010DEED = "http://creativecommons.org/publicdomain/zero/1.0/",
  ITFFFL = "https://www.fontshare.com/licenses/itf-ffl"
}

enum Contact {
  Email = "onrush.facades-0o@icloud.com"
}

export { Urls, UrlsLicenses, Strings, Contact };
